import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    style: _normalizeStyle({ marginBottom: $props.noMargin ? 0 : '32px' }),
    class: _normalizeClass($props.classes)
  }, _toDisplayString($setup.props.text), 7 /* TEXT, CLASS, STYLE */))
}